import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { DatePicker } from 'primeng/datepicker';

interface DatePickerProps extends CoreFormlyFieldProps {
  placeholder?: string;
  dateFormat?: string;
  showTime?: boolean;
  showButtonBar?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

@Component({
  selector: 'formly-field-primeng-datepicker',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    DatePicker
  ],
  template: `
    <p-datepicker
      [id]="id"
      [formControl]="datepickerControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder || ''"
      [dateFormat]="props.dateFormat || 'yy/mm/dd'"
      [showTime]="props.showTime || false"
      [showButtonBar]="props.showButtonBar"
      [minDate]="props.minDate"
      [maxDate]="props.maxDate"
      class="w-full"
      [class.ng-dirty]="showError"
      [class.ng-invalid]="showError"
    ></p-datepicker>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldDatePicker extends FieldType<FormlyFieldConfig<DatePickerProps>> {
  get datepickerControl() {
    return this.formControl as FormControl;
  }
}